import React from "react";

const ASP_Session = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Session</h1>
      <p>This is the ASP Session page content.</p>
    </div>
  );
};

export default ASP_Session;
